import {
  useCurrentWorkspace,
  useProductFilter,
  useSetProductFilter,
} from '@gripp/shared-logic';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { TextInput } from 'react-native-paper';
import { Colors } from '../../themes';
import { DebouncedTextInput } from '../forms';

export const ProductsSearchInput = () => {
  const { t } = useTranslation();
  const { data: productFilter } = useProductFilter();
  const { mutateAsync: setProductFilter } = useSetProductFilter();

  const currentWorkspaceId = useCurrentWorkspace();

  const [text, setText] = useState('');

  useEffect(() => {
    if (!text && productFilter?.keyword) {
      setText(productFilter.keyword);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productFilter?.keyword]);

  const updateSearch = async (term: string) => {
    if (!productFilter) return;
    // productFilter.workspaceId = currentWorkspaceId;
    productFilter.keyword = term;
    await setProductFilter(productFilter);
  };

  return (
    productFilter && (
      <DebouncedTextInput
        debounceTimeMs={500}
        debounceFunc={updateSearch}
        placeholder={t('product.filter.searchPlaceholder')}
        value={text}
        onBlur={() => null}
        onChangeText={(text) => setText(text)}
        left={<TextInput.Icon icon="magnify" color={Colors.grayFill} />}
        right={
          text ? (
            <TextInput.Icon
              icon="close"
              size={20}
              color={Colors.black}
              onPress={() => setText('')}
            />
          ) : (
            <View />
          )
        }
        height={44}
        outlineStyle={styles.inputStyle}
        disableInnerStyle={true}
      />
    )
  );
};

const styles = StyleSheet.create({
  inputStyle: {
    backgroundColor: Colors.white,
    borderColor: Colors.grayDivider,
    borderWidth: 1,
    borderRadius: 8,
  },
});
